import { inject, Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Profile } from "../../models/core/profile.interface";
import { IdentityService } from "../identity/identity.service";

@Injectable({
  providedIn: "root"
})
export class ProfileService {
  private readonly identityService = inject(IdentityService);

  public getProfiles(): Observable<Profile[]> {
    return this.identityService.getProfileTypes().pipe(
      map((profileTypes) =>
        profileTypes.map((profileType) => ({
          idProfile: profileType.idProfileType,
          txName: profileType.txProfileType,
          canUseInContent: profileType.canUseInContent
        }))
      )
    );
  }
}
